export default __webpack_public_path__ + "static/media/sidebar_img.2148164a.png";